export default __webpack_public_path__ + "static/media/IconDesc_Cables.256.02729de4.png";